import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/DropdownInput/DropdownInput.js";
import React, { useEffect, useState } from 'react';
import { noop } from '../../helpers';
import styled, { css } from 'styled-components';
import space from '@styled-system/space';
import ArrowDownIcon from '@dls/assets/icons/ArrowDown';
import ArrowUpIcon from '@dls/assets/icons/ArrowUp';
import FormField, { FormFieldContext } from '../../core/components/Forms/FormField';
import FormInput from '../../core/components/Forms/FormInput';
import LabelText from '../../core/components/Forms/LabelText';
import FormFieldHint from '../../core/components/Forms/FormFieldHint';
import HintText from '../../core/components/Forms/HintText';
import { withTheme } from '../../core/ThemeProvider';
import Divider from '../Divider';
import DropdownActionItem from './DropdownActionItem';
import DropdownActionLink from './DropdownActionLink';
import { responsiveStyles } from '../../core/utils/responsiveStyles';
/* eslint-disable-next-line react/display-name */

var DropdownInput = /*#__PURE__*/React.forwardRef(function DropdownInput(_ref, ref) {
  var _this = this;
  var zIndex = _ref.zIndex,
    value = _ref.value,
    defaultValue = _ref.defaultValue,
    id = _ref.id,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    label = _ref.label,
    hintMessage = _ref.hintMessage,
    onChange = _ref.onChange,
    hasSearch = _ref.hasSearch,
    onSearch = _ref.onSearch,
    error = _ref.error,
    coreTheme = _ref.coreTheme,
    bgColor = _ref.bgColor;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    dropdownVisible = _useState2[0],
    setDropDownVisible = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedItem = _useState4[0],
    setSelectedItem = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    inputText = _useState6[0],
    setInputText = _useState6[1];
  var onDropdownClick = function onDropdownClick(_, formField) {
    focusOnField(formField);
    setDropDownVisible(true);
  };
  var onItemClick = function onItemClick(item) {
    setSelectedItem(item);
    setInputText(hasSearch || !item.rightText ? item.text : "".concat(item.text, " ").concat(item.rightText));
    setDropDownVisible(false);
    return onChange(item);
  };
  var handleType = function handleType(event, formField) {
    var text = event.target.value;
    focusOnField(formField);
    setInputText(text);
    onSearch(event, text);
    if (!dropdownVisible) {
      setDropDownVisible(true);
    }
  };
  var isSelected = function isSelected(_ref2) {
    var text = _ref2.text,
      rightText = _ref2.rightText;
    var current = rightText ? "".concat(text, " ").concat(rightText) : text;
    return inputText === current;
  };
  var focusOnField = function focusOnField(formField) {
    if (!formField.hasFocus) {
      formField.onFocus();
    }
  };
  var handleValueChange = function handleValueChange(val) {
    var currentItem = items.find(function (item) {
      return item.value && item.value === val;
    });
    if (currentItem) {
      setSelectedItem(currentItem);
      setInputText(hasSearch || !currentItem.rightText ? currentItem.text : "".concat(currentItem.text, " ").concat(currentItem.rightText));
    } else {
      setSelectedItem({});
      setInputText('');
    }
  };
  useEffect(function () {
    handleValueChange(value);
  }, [value]); // Always keep it as last to avoid calling multiple re render

  useEffect(function () {
    !value && defaultValue && handleValueChange(defaultValue);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 109,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(FormField, {
    defaultValue: defaultValue || value,
    "data-testid": "dropdownId",
    error: error,
    bgColor: bgColor,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 110,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(FormFieldContext.Consumer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 117,
      columnNumber: 9
    }
  }, function (formFieldContext) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldWrapper, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 120,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement(LabelWrapper, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 121,
        columnNumber: 17
      }
    }, selectedItem && selectedItem.leftImage && /*#__PURE__*/React.createElement(ImageContainer, {
      pr: 3,
      pt: 1,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 123,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: selectedItem.leftImage,
      alt: selectedItem.text,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 124,
        columnNumber: 23
      }
    })), /*#__PURE__*/React.createElement(FormInput, {
      id: id,
      ref: ref,
      type: "text",
      readOnly: !hasSearch,
      onChange: function onChange(e) {
        return handleType(e, formFieldContext);
      },
      value: inputText || '',
      onClick: function onClick(e) {
        return onDropdownClick(e, formFieldContext);
      },
      onBlur: function onBlur() {
        return setDropDownVisible(false);
      },
      autoComplete: "off",
      "data-testid": "inputTextId",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 131,
        columnNumber: 19
      }
    })), /*#__PURE__*/React.createElement(IconWrapper, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 144,
        columnNumber: 17
      }
    }, dropdownVisible ? /*#__PURE__*/React.createElement(ArrowUpIcon, {
      size: 24,
      color: coreTheme.cl_sec_d1,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 146,
        columnNumber: 21
      }
    }) : /*#__PURE__*/React.createElement(ArrowDownIcon, {
      size: 24,
      color: coreTheme.cl_sec_d1,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 148,
        columnNumber: 21
      }
    })), /*#__PURE__*/React.createElement(LabelText, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 151,
        columnNumber: 17
      }
    }, label)), /*#__PURE__*/React.createElement(ItemsWrapper, {
      zIndex: zIndex,
      dropdownVisible: dropdownVisible && formFieldContext.hasFocus,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 153,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement(OptionViewport, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 157,
        columnNumber: 17
      }
    }, items.map(function (item, index) {
      if ( /*#__PURE__*/React.isValidElement(item)) {
        return item;
      }
      switch (item.type) {
        case 'header':
          return /*#__PURE__*/React.createElement(SectionTitle, {
            key: index,
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 165,
              columnNumber: 27
            }
          }, item.text);
        case 'divider':
          return /*#__PURE__*/React.createElement(DividerWrapper, {
            key: index,
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 170,
              columnNumber: 27
            }
          }, /*#__PURE__*/React.createElement(Divider, {
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 171,
              columnNumber: 29
            }
          }));
        default:
          return /*#__PURE__*/React.createElement(OptionItem, {
            onClick: function onClick(e) {
              e.preventDefault();
              formFieldContext.onBlur();
              return onItemClick(item);
            },
            key: index,
            "data-testid": 'optArrayId-' + index,
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 177,
              columnNumber: 27
            }
          }, item.leftImage && /*#__PURE__*/React.createElement(ImageContainer, {
            pr: 3,
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 188,
              columnNumber: 31
            }
          }, /*#__PURE__*/React.createElement("img", {
            src: item.leftImage,
            alt: item.text,
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 189,
              columnNumber: 33
            }
          })), /*#__PURE__*/React.createElement(MainText, {
            isSelected: isSelected(item),
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 193,
              columnNumber: 29
            }
          }, item.text), item.rightText && /*#__PURE__*/React.createElement(RightText, {
            isSelected: isSelected(item),
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 198,
              columnNumber: 31
            }
          }, item.rightText));
      }
    }))));
  })), hintMessage && /*#__PURE__*/React.createElement(FormFieldHint, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 213,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(HintText, {
    error: error,
    "data-testid": "errorId",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 214,
      columnNumber: 11
    }
  }, hintMessage)));
});
DropdownInput.defaultProps = {
  zIndex: 1,
  error: false,
  onChange: noop,
  onSearch: noop,
  bgColor: 'white'
};
export var FieldWrapper = withTheme(styled.div.withConfig({
  displayName: "DropdownInput__FieldWrapper",
  componentId: "sc-15z9jqn-0"
})(["display:flex;padding-right:", "px;"], function (_ref3) {
  var coreTheme = _ref3.coreTheme;
  return coreTheme.space_9;
}));
export var LabelWrapper = styled.div.withConfig({
  displayName: "DropdownInput__LabelWrapper",
  componentId: "sc-15z9jqn-1"
})(["display:flex;align-items:center;flex:1 1 100%;"]);
export var IconWrapper = withTheme(styled.div.withConfig({
  displayName: "DropdownInput__IconWrapper",
  componentId: "sc-15z9jqn-2"
})(["position:absolute;top:", ";right:", "px;"], function (_ref4) {
  var _coreTheme$dropDownIn, _coreTheme$dropDownIn2;
  var coreTheme = _ref4.coreTheme;
  return (_coreTheme$dropDownIn = coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$dropDownIn2 = coreTheme.dropDownInput) === null || _coreTheme$dropDownIn2 === void 0 ? void 0 : _coreTheme$dropDownIn2.topIconWrapper) !== null && _coreTheme$dropDownIn !== void 0 ? _coreTheme$dropDownIn : '30px';
}, function (_ref5) {
  var coreTheme = _ref5.coreTheme;
  return coreTheme.space_4;
}));
export var SelectedText = withTheme(styled.div.withConfig({
  displayName: "DropdownInput__SelectedText",
  componentId: "sc-15z9jqn-3"
})(["", ";transition:0.2s ease;opacity:", ";"], function (_ref6) {
  var _coreTheme$dropDownIn3, _coreTheme$dropDownIn4;
  var coreTheme = _ref6.coreTheme;
  return css(["font-family:", ";color:", ";height:", "px;line-height:", "px;margin-top:4px;", ";"], (_coreTheme$dropDownIn3 = (_coreTheme$dropDownIn4 = coreTheme.dropDownInput) === null || _coreTheme$dropDownIn4 === void 0 ? void 0 : _coreTheme$dropDownIn4.fontFamily) !== null && _coreTheme$dropDownIn3 !== void 0 ? _coreTheme$dropDownIn3 : coreTheme.ff_sec_thin, coreTheme.cl_ter_base, coreTheme.space_6, coreTheme.space_6, function (_ref7) {
    var _coreTheme$dropDownIn5;
    var coreTheme = _ref7.coreTheme;
    return Object.assign({}, responsiveStyles({
      fontSize: ((_coreTheme$dropDownIn5 = coreTheme.dropDownInput) === null || _coreTheme$dropDownIn5 === void 0 ? void 0 : _coreTheme$dropDownIn5.fontSize) || coreTheme.fs_xl
    }, coreTheme));
  });
}, function (p) {
  return p.hasValue ? 1 : 0;
}));
var ItemsWrapper = withTheme(styled.div.withConfig({
  displayName: "DropdownInput__ItemsWrapper",
  componentId: "sc-15z9jqn-4"
})(["position:absolute;width:100%;top:calc(100% + 8px);left:0;border-radius:8px;", ";padding:16px 0;box-sizing:border-box;z-index:", ";overflow:hidden;display:", ";transition-property:all;transition-duration:0.2s;", ";"], function (_ref8) {
  var _coreTheme$dropDownIn6, _coreTheme$dropDownIn7;
  var coreTheme = _ref8.coreTheme;
  return css(["font-family:", ";border:1px solid ", ";background-color:", ";"], (_coreTheme$dropDownIn6 = (_coreTheme$dropDownIn7 = coreTheme.dropDownInput) === null || _coreTheme$dropDownIn7 === void 0 ? void 0 : _coreTheme$dropDownIn7.fontFamily) !== null && _coreTheme$dropDownIn6 !== void 0 ? _coreTheme$dropDownIn6 : coreTheme.ff_sec_thin, coreTheme.cl_ter_l4, coreTheme.cl_white);
}, function (_ref9) {
  var zIndex = _ref9.zIndex;
  return zIndex;
}, function (_ref10) {
  var dropdownVisible = _ref10.dropdownVisible;
  return dropdownVisible ? 'block' : 'none';
}, function (_ref11) {
  var _coreTheme$dropDownIn8;
  var coreTheme = _ref11.coreTheme;
  return Object.assign({}, responsiveStyles({
    fontSize: ((_coreTheme$dropDownIn8 = coreTheme.dropDownInput) === null || _coreTheme$dropDownIn8 === void 0 ? void 0 : _coreTheme$dropDownIn8.fontSize) || 'inherit'
  }, coreTheme));
}));
var SectionTitle = withTheme(styled.div.withConfig({
  displayName: "DropdownInput__SectionTitle",
  componentId: "sc-15z9jqn-5"
})(function (_ref12) {
  var _coreTheme$dropDownIn9, _coreTheme$dropDownIn10;
  var coreTheme = _ref12.coreTheme;
  return css(["font-family:", ";", ";line-height:", "px;color:", ";padding:", "px ", "px;"], (_coreTheme$dropDownIn9 = (_coreTheme$dropDownIn10 = coreTheme.dropDownInput) === null || _coreTheme$dropDownIn10 === void 0 ? void 0 : _coreTheme$dropDownIn10.fontFamily) !== null && _coreTheme$dropDownIn9 !== void 0 ? _coreTheme$dropDownIn9 : coreTheme.ff_sec_bold, function (_ref13) {
    var _coreTheme$dropDownIn11;
    var coreTheme = _ref13.coreTheme;
    return Object.assign({}, responsiveStyles({
      fontSize: ((_coreTheme$dropDownIn11 = coreTheme.dropDownInput) === null || _coreTheme$dropDownIn11 === void 0 ? void 0 : _coreTheme$dropDownIn11.fontSize) || coreTheme.fs_md
    }, coreTheme));
  }, coreTheme.space_6, coreTheme.cl_ter_base, coreTheme.space_2, coreTheme.space_4);
}));
export var DividerWrapper = withTheme(styled.div.withConfig({
  displayName: "DropdownInput__DividerWrapper",
  componentId: "sc-15z9jqn-6"
})(function (_ref14) {
  var coreTheme = _ref14.coreTheme;
  return css(["padding:", "px ", "px;"], coreTheme.space_6, coreTheme.space_4);
}));
var OptionViewport = withTheme(styled.div.withConfig({
  displayName: "DropdownInput__OptionViewport",
  componentId: "sc-15z9jqn-7"
})(["height:100%;max-height:200px;overflow-y:auto;overflow-x:hidden;", ""], function (_ref15) {
  var coreTheme = _ref15.coreTheme;
  return css(["background-color:", ";@media (min-width:", "){", ";}"], coreTheme.cl_white, /* sc-value */
  coreTheme.brk_md, css(["max-height:316px;"]));
}));
var OptionItem = withTheme(styled.span.withConfig({
  displayName: "DropdownInput__OptionItem",
  componentId: "sc-15z9jqn-8"
})(function (_ref16) {
  var _coreTheme$dropDownIn12, _coreTheme$dropDownIn13;
  var coreTheme = _ref16.coreTheme;
  return css(["display:flex;transition:all 0.2s ease;font-family:", ";", ";align-content:center;background-color:", ";padding:", "px ", "px;color:", ";&:hover{background-color:", ";span{", "}}"], (_coreTheme$dropDownIn12 = (_coreTheme$dropDownIn13 = coreTheme.dropDownInput) === null || _coreTheme$dropDownIn13 === void 0 ? void 0 : _coreTheme$dropDownIn13.fontFamily) !== null && _coreTheme$dropDownIn12 !== void 0 ? _coreTheme$dropDownIn12 : coreTheme.secondaryThin, function (_ref17) {
    var _coreTheme$dropDownIn14;
    var coreTheme = _ref17.coreTheme;
    return Object.assign({}, responsiveStyles({
      fontSize: ((_coreTheme$dropDownIn14 = coreTheme.dropDownInput) === null || _coreTheme$dropDownIn14 === void 0 ? void 0 : _coreTheme$dropDownIn14.fontSize) || coreTheme.fs_xl
    }, coreTheme));
  }, coreTheme.cl_white, coreTheme.space_2, coreTheme.space_4, coreTheme.cl_ter_base, coreTheme.cl_sec_l2, HighlightTextCss(coreTheme));
}));
var ImageContainer = styled.div.withConfig({
  displayName: "DropdownInput__ImageContainer",
  componentId: "sc-15z9jqn-9"
})(["", ";width:36px;height:auto;flex-grow:0;> img{width:100%;}"], space);
export var MainText = withTheme(styled.span.withConfig({
  displayName: "DropdownInput__MainText",
  componentId: "sc-15z9jqn-10"
})(["display:block;flex:1 1 50%;word-break:break-all;", ""], function (_ref18) {
  var isSelected = _ref18.isSelected,
    coreTheme = _ref18.coreTheme;
  return isSelected && HighlightTextCss(coreTheme);
}));
var RightText = withTheme(styled.span.withConfig({
  displayName: "DropdownInput__RightText",
  componentId: "sc-15z9jqn-11"
})(["display:flex;", ""], function (_ref19) {
  var isSelected = _ref19.isSelected,
    coreTheme = _ref19.coreTheme;
  return isSelected && HighlightTextCss(coreTheme);
}));
var HighlightTextCss = function HighlightTextCss(coreTheme) {
  var _coreTheme$dropDownIn15, _coreTheme$dropDownIn16, _coreTheme$dropDownIn17, _coreTheme$dropDownIn18, _coreTheme$dropDownIn19, _coreTheme$dropDownIn20;
  return css(["font-weight:", ";font-family:", ";color:", ";"], (_coreTheme$dropDownIn15 = (_coreTheme$dropDownIn16 = coreTheme.dropDownInput) === null || _coreTheme$dropDownIn16 === void 0 ? void 0 : _coreTheme$dropDownIn16.fontWeight) !== null && _coreTheme$dropDownIn15 !== void 0 ? _coreTheme$dropDownIn15 : 900, (_coreTheme$dropDownIn17 = (_coreTheme$dropDownIn18 = coreTheme.dropDownInput) === null || _coreTheme$dropDownIn18 === void 0 ? void 0 : _coreTheme$dropDownIn18.fontFamily) !== null && _coreTheme$dropDownIn17 !== void 0 ? _coreTheme$dropDownIn17 : coreTheme.ff_sec_regular, (_coreTheme$dropDownIn19 = (_coreTheme$dropDownIn20 = coreTheme.dropDownInput) === null || _coreTheme$dropDownIn20 === void 0 ? void 0 : _coreTheme$dropDownIn20.color) !== null && _coreTheme$dropDownIn19 !== void 0 ? _coreTheme$dropDownIn19 : coreTheme.cl_sec_d1);
};
var ThemedDropdownInput = withTheme(DropdownInput);
ThemedDropdownInput.ActionItem = DropdownActionItem;
ThemedDropdownInput.ActionLink = DropdownActionLink;
export default ThemedDropdownInput;